import effectiveHostsCookie from './effectiveHostsCookie';

type CachedOrganization = {
  effectiveHost: string;
};

function getAllEffectiveHosts() {
  return effectiveHostsCookie.get() || [];
}

function saveEffectiveHosts(hosts: string[]) {
  effectiveHostsCookie.set(hosts);
}

function add(organization: CachedOrganization) {
  const effectiveHosts = getAllEffectiveHosts();
  saveEffectiveHosts([
    organization.effectiveHost,
    ...effectiveHosts.filter((host) => host !== organization.effectiveHost),
  ]);
}

function remove(organization: CachedOrganization) {
  const newEffectiveHosts = getAllEffectiveHosts().filter(
    (savedHost) => savedHost !== organization.effectiveHost,
  );
  saveEffectiveHosts(newEffectiveHosts);
}

function removeByEffectiveHost(host: string) {
  const newTeams = getAllEffectiveHosts().filter(
    (savedHost) => savedHost !== host,
  );
  saveEffectiveHosts(newTeams);
}

function removeAll() {
  effectiveHostsCookie.remove();
}

const LoggedInTeams = {
  add,
  getAllEffectiveHosts,
  remove,
  removeByEffectiveHost,
  removeAll,
};

export default LoggedInTeams;
